import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import * as ArbetsorderConstants from "~app/features/planera/model/ArbetsorderConstants";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";

export class ArbetsorderInformationValidation {
    static init(arbetsorder: IArbetsorderDetail): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.spara, ValidationErrorLevels.error).withRules([
            {
                name: "arbetsordernamn",
                model: () => arbetsorder.namn,
                expression: x => x.length <= ArbetsorderConstants.ArbetsordernamnMaxLength,
                applicable: x => true,
                message: { text: "Arbetsorderns namn kan inte överstiga 30 tecken" },
                errorLevel: ValidationErrorLevels.error
            },
            {
                name: "arbetsorderVirketMarkt",
                model: () => arbetsorder.virketMarkt,
                applicable: x => x !== undefined && x !== null && x !== "",
                expression: x => x.length <= 10,
                message: { text: "Virket märkt kan inte överstiga 10 tecken" },
                errorLevel: ValidationErrorLevels.error
            },
            {
                name: "verifieringsnummer",
                model: () => arbetsorder.verifieringsnummer,
                expression: x => x.length >= 5,
                applicable: x =>  arbetsorder.isTerminalImport && arbetsorder.viol3 && x !== undefined && x !== null && x !== "",
                message: { text: "Verifieringsnumret måste vara 5 tecken långt" },
                errorLevel: ValidationErrorLevels.error
            },
            {
                name: "batId",
                model: () => arbetsorder.batId,
                expression: batId => {

                    if (!batId || batId.length === 0) {
                        return true;
                    }

                    if (batId.length !== 6 && batId.length > 0) {
                        return false;
                    }
                    const regex = /^ID\d{4}$/;
                    return regex.test(batId);
                },
                applicable: x => arbetsorder.transportslag === "Sjötransport",
                message: { text: "BåtId måste vara i format: IDXXXX där X är siffror" },
                errorLevel: ValidationErrorLevels.error
            }
        ]);
        return context;
    }
}
